import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TaskService} from '../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'nf-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  boardId: string; // 面板ID
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  statusWidth = 135; // 标签组件下拉框动态宽度
  isEditVisual = true; // 标签组件下拉框按钮状态
  statusInit = []; // 存放初始状态色块
  statusTemp = []; // 存放操作过程中状态
  statusDel = []; // 存放移除掉的状态;
  addTabBGColor = '#F7F7F7'; // 添加标签默认背景颜色
  isDisabled = false;
  popVisible = false;
  editing = false;
  isVisible = false;
  remarks: string;
  currentPulseId: string;
  currentColumn: any;
  currentStatus: any;
  getState: boolean;
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardId = this.boardData.id;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
  }
  @Input('nfGroupData') set ChangeGroupData(data: any) {
    if (data) {
      this.group = data;
    }
  }
  @Input('nfColumnData') set ChangeColumnData(data: any) {
    if (data) {
      this.column = data;
    }
  }
  @Input('nfPulseData') set ChangePulseData(data: any) {
    if (data) {
      this.pulse = data;
    }
  }
  @Input('nfDisabled') set changeDisabled(val: boolean) {
    this.isDisabled = val;
  }
  @Output() updateFilterData: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit() {
    this.statusInit = JSON.parse(localStorage.getItem('statusInit'));
    this.statusWidth = this.statusInit.length / 4 * 122;
  }
// 更换状态标签
  clickStatus() {
    this.editing = false;
    this.isEditVisual = true;
    this.statusWidth = this.statusInit.length / 4 * 122;
  }
  // 鼠标移入移出添加标签背景变色
  mouseEnterStatus(color) {
    this.addTabBGColor = color;
  }
  mouseLeaveStatus() {
    this.addTabBGColor = '#F7F7F7';
  }
  changeStatus(pulseId, column, status) {
    this.currentPulseId = pulseId;
    this.currentColumn = column;
    this.currentStatus = status;
    // 判断是否配置了请求
    if (status && status.url) {
      let url = status.url;
      if (status.context) {
        url = '/' + status.context + status.url;
      }
      this.queryStatusRequest(url, pulseId, column, status);
    } else {
      column.labels.forEach((item, i) => {
        if (item.relationStatus && item.relationStatus === status.index) {
          this.isVisible = true;
        } else {
          this.setStatus(pulseId, column, status);
        }
      });
    }
  }
  // 置状态
  setStatus(pulseId, column, status) {
    if (!this.pulse.columnValues) {
      this.pulse.columnValues = {};
      this.pulse.columnValues[column.id] = {};
    }
    this.editing = true;
    // 如果所选标签和当前标签一样，则不发起更改请求
    if (this.pulse.columnValues[column.id]['index'] === status['index']) {
      this.popVisible = false;
      return;
    }
    this.pulse.columnValues[column.id]['index'] = status.index;
    // 计算进度
    this.progressCalcValue();
    // 提交选中状态
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = column.id;
    param['columnValue'] = status;
    this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      this.popVisible = false;
      this.updateFilterData.emit();
    });
  }
  // 标签组件切换到编辑状态
  editStatus(column, pulse) {
    this.isEditVisual = !this.isEditVisual;
    // 处理编辑状态选项
    this.statusTemp = column.labels;
    // 获取面板所有状态已用标签
    const tempList = [];
    this.boardPulseData.forEach((list, i) => {
      for (let k = 0; k < this.boardColumnData.length; k++) {
        if (this.boardColumnData[k].type === 'status') {
          if (list.columnValues[this.boardColumnData[k].id] && JSON.stringify(list.columnValues[this.boardColumnData[k].id]) !== '{}') {
            tempList.push(list.columnValues[this.boardColumnData[k].id].index);
          }
        }
      }
    });
    this.statusTemp.map((item, i) => {
      item.use = false;
    });
    tempList.forEach((item, index) => {
      for (let i = 0; i < this.statusTemp.length; i++) {
        this.statusTemp[i].use = false;
        if (item === this.statusTemp[i].index) {
          this.statusTemp[i].use = true;
        }
      }
    });
    // 状态标签未选列表
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    this.statusDel = arr;
  }
  // 标签组件提交编辑
  submitEditStatus(columnId, boardId) {
    const param = {
      'labels': this.statusTemp
    };
    this.taskService.doAddStatusLabel(boardId, columnId, param).subscribe((res: any) => {
      this.boardColumnData.forEach((item, index) => {
        if (item.id === columnId) {
          item.labels = this.statusTemp;
        }
        let count = 0;
        if (item.type === 'status') {
          for (let i = 0; i < item.labels.length; i++) {
            if (item.labels[i].index === 0) {
              count = count + 1;
            }
          }
          if (count === 0) {
            if (item.type === 'status') {
              const o = {
                'color': 'rgb(196, 196, 196)',
                'index': 0,
                'label': ''
              };
              item.labels.push(o);
            }
          }
        }
      });
      this.isEditVisual = !this.isEditVisual;
    });
  }
  // 删除状态标签
  removeStatusTag(id) {
    this.statusTemp = this.statusTemp.filter(d => d.index !== id);
    this.statusInit.forEach((item, index) => {
      if (id === item.index) {
        this.statusDel.push(item);
      }
    });
  }
  // 添加状态标签
  addStatusTag() {
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    if (arr.length > 0) {
      this.statusTemp = [
        ...this.statusTemp,
        {
          index: arr[0].index,
          label: '',
          color: arr[0].color
        }
      ];
      this.statusDel = this.statusDel.filter(d => d.color !== arr[0].color);
    }
  }
  // 添加自定义颜色标签
  addCustomTag(index) {
    const arr = this.statusInit.filter(obj => !this.statusTemp.some(obj1 => obj1.index === obj.index));
    if (arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        if (index === arr[i].index) {
          this.statusTemp = [
            ...this.statusTemp,
            {
              index: arr[i].index,
              label: '',
              color: arr[i].color
            }
          ];
          this.statusDel = this.statusDel.filter(d => d.index !== arr[i].index);
        }
      }
    }
    this.addTabBGColor = '#F7F7F7';
  }
  // 计算标签组件框宽度
  getStatusWidth(label, type?: any) {
    const len = label.length + 1;
    const width = 134;
    if (len > 4) {
      this.statusWidth = Number.isInteger(len / 4) ? len / 4 * width : Math.ceil(len / 4) * width;
    } else {
      this.statusWidth = width;
    }
    return {'width': this.statusWidth + 'px'};
  }
  // 进度条组件-根据进度分配权重计算进度值
  progressCalcValue() {
    const value = [];
    const progressId = [];
    for (const key in this.boardColumnData) {
      if (this.boardColumnData.hasOwnProperty(key)) {
        if (this.boardColumnData[key].type === 'status' && this.boardColumnData[key].value && this.boardColumnData[key].checked) {
          const o = {
            key: this.boardColumnData[key].id,
            value: Number(this.boardColumnData[key].value)
          };
          value.push(o);
        }
        if (this.boardColumnData[key].type === 'progress') {
          progressId.push(this.boardColumnData[key].id);
        }
      }
    }
    for (let i = 0; i < this.boardPulseData.length; i++) {
      let num = 0;
      for (const key in this.boardPulseData[i].columnValues) {
        if (this.boardPulseData[i].columnValues.hasOwnProperty(key)) {
          for (let j = 0; j < progressId.length; j++) {
            if (progressId[j] === key) {
              this.boardPulseData[i].columnValues[key] = 0;
            }
          }
        }
      }
      for (let j = 0; j < value.length; j++) {
        if (this.boardPulseData[i].columnValues[value[j].key].index === 2) {
          num = num + value[j].value;
          for (const key in this.boardPulseData[i].columnValues) {
            if (this.boardPulseData[i].columnValues.hasOwnProperty(key)) {
              for (let k = 0; k < progressId.length; k++) {
                if (progressId[k] === key) {
                  this.boardPulseData[i].columnValues[key] = num;
                }
              }
            }
          }
        }
      }
    }
  }
  queryStatusRequest(url, pulseId, column, status) {
    const param = {
      taskId: pulseId.dataId
    };
    this.taskService.queryStatus(url, param).subscribe((res: any) => {
      if (res === 'abnormal') {
        this.getState = false;
        this.message.create('warning', '无法置' + status.label + '状态，请检查！');
      } else if (res === 'normal') {
        this.getState = true;
        this.setStatus(pulseId, column, status);
      }
    }, () => {
      this.message.create('warning', '无法置' + status.label + '状态，请检查！');
    });
  }
  handleOk() {
    const param = {};
    param['pulseIds'] = [this.currentPulseId];
    param['columnId'] = this.currentColumn.id;
    param['columnValue'] = this.currentStatus;
    param['columnValue']['remarks'] = this.remarks;
    this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      this.isVisible = false;
      this.setStatus(this.currentPulseId, this.currentColumn, this.currentStatus);
      this.updateFilterData.emit();
    });
  }
  handleCancel() {
    this.isVisible = false;
  }
}
